import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое развитие персонала?',
    a: 'Развитие персонала — это система, которая помогает сотрудникам становиться сильнее в своей роли: приобретать необходимые компетенции, применять их в работе и постепенно брать на себя больше ответственности. Оно объединяет диагностику, обучение, практику, наставничество, обратную связь, оценку прогресса и подготовку кадрового резерва.',
  },
  {
    q: 'Чем развитие персонала отличается от обучения?',
    a: 'Обучение — это получение знаний и навыков, а развитие — их применение в работе. Обучение является частью развития, но само по себе не гарантирует изменения в поведении сотрудника. Развитие включает практику, обратную связь, наставничество, развивающие задачи и оценку прогресса.',
  },
  {
    q: 'Зачем компании развивать сотрудников?',
    a: 'Системное развитие персонала помогает повысить самостоятельность сотрудников, улучшить качество работы, снизить зависимость от отдельных сильных специалистов, сформировать кадровый резерв и связать обучение с задачами бизнеса. Без системного подхода опыт не передаётся внутри команды, а после разовых тренингов сотрудники возвращаются к прежним привычкам.',
  },
  {
    q: 'Какие направления развития персонала существуют?',
    a: 'Основные направления: обучение сотрудников, развитие soft skills, адаптация новых сотрудников, наставничество, оценка эффективности обучения, разработка программ обучения, корпоративная академия, тренинг для руководителей и развитие управленческих компетенций. Компания может выбрать отдельное направление или комплексную программу.',
  },
  {
    q: 'Как определить, какие компетенции необходимо развивать?',
    a: 'Развитие начинается с определения бизнес-задач: какие результаты необходимо улучшить. Затем определяется, какие компетенции сотрудников влияют на эти результаты, проводится диагностика текущего уровня и выявляются дефициты. На основе этого формируется программа развития, связанная с реальными задачами компании.',
  },
  {
    q: 'Как оценить уровень сотрудников перед обучением?',
    a: 'Перед обучением проводится диагностика: интервью, анализ рабочих ситуаций, наблюдение, сбор обратной связи от руководителей. Цель — понять, что сотрудники уже умеют, где находятся дефициты и какие навыки влияют на бизнес-результаты. Это позволяет не проводить обучение ради обучения, а нацелить его на реальные потребности.',
  },
  {
    q: 'Как составить план развития сотрудника?',
    a: 'Хороший план развития отвечает на вопросы: какую компетенцию развиваем и зачем она нужна, какой текущий уровень и какой необходимо получить, какие действия выполняет сотрудник, кто помогает, как измеряется прогресс и когда проводится повторная оценка. План превращает абстрактное развитие в конкретные шаги.',
  },
  {
    q: 'Что такое индивидуальный план развития?',
    a: 'Индивидуальный план развития (ИПР) — это документ, который фиксирует конкретную компетенцию, цель развития, текущий и целевой уровни, действия сотрудника, ответственных и критерии измерения прогресса. Он нужен не каждому сотруднику, а в ситуациях, когда требуется точечное развитие конкретных навыков.',
  },
  {
    q: 'Как развивать сотрудников внутри компании?',
    a: 'Развитие внутри компании опирается на несколько инструментов: обучение, развивающие задачи, наставничество, участие в проектах, расширение ответственности, регулярная обратная связь и оценка прогресса. Важно, чтобы новые навыки применялись в реальной работе, а не оставались на уровне полученных знаний.',
  },
  {
    q: 'Как наставничество помогает развитию персонала?',
    a: 'Наставничество позволяет развивать сотрудников непосредственно в рабочем процессе: передавать опыт, помогать осваивать новые задачи, разбирать ошибки и давать обратную связь. Оно повышает самостоятельность сотрудников и готовит их к новым ролям быстрее, чем изолированное обучение.',
  },
  {
    q: 'Как формировать кадровый резерв?',
    a: 'Кадровый резерв — это не просто список перспективных сотрудников, а условия для их развития. Для подготовки будущих руководителей используются развивающие задачи, наставничество, участие в проектах, расширение ответственности, обучение управленческим компетенциям, обратная связь и оценка готовности к новой роли.',
  },
  {
    q: 'Как оценить эффективность развития сотрудников?',
    a: 'Эффективность оценивается через повторную диагностику: изменились ли компетенции, применяются ли новые навыки в работе, как изменилось поведение сотрудников и повлияло ли это на бизнес-показатели. Оценка через 1-3 месяца после обучения показывает, закрепились ли изменения или остались только на уровне знаний.',
  },
  {
    q: 'Можно ли разработать индивидуальную программу развития для компании?',
    a: 'Да. Индивидуальная программа разрабатывается под конкретную категорию сотрудников или задачу компании. Сначала проводится диагностика и определяются дефициты, затем формируется цель, подбирается обучение, практика и обратная связь, а в завершение проводится повторная оценка.',
  },
  {
    q: 'Сколько времени занимает программа развития персонала?',
    a: 'Продолжительность зависит от задач и формата. Корпоративный тренинг занимает 1-3 дня, модульная программа — несколько этапов с практикой между встречами, комплексная программа развития может длиться несколько месяцев. Точная продолжительность определяется после диагностики потребностей компании.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы о развитии персонала
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}